const moveBar = (e) => {
    e.preventDefault();
    const currentEl = e.target;
    const currentId = currentEl.getAttribute('href');
    const sustentItem = document.querySelector(currentId);
    // window.location.hash = currentId;
    const currentUrl = window.location.href;
    const newUrl = `${window.location.origin}${window.location.pathname}${currentId}`;
    history.replaceState(null, null, newUrl);
    // sustentItem.scrollIntoView({ behavior: "smooth", block: 'start', blockOffset: -200 });
    const { top } = sustentItem.getBoundingClientRect();
    
    if(window.innerWidth < 899) {
        window.scrollTo({
            // top: window.scrollY + top + 50,
            top: window.scrollY + top + 10,
            behavior: 'smooth'
        });
    }else{
        window.scrollTo({
            // top: window.scrollY + top + 50,
            top: window.scrollY + top + 50,
            behavior: 'smooth'
        });
    }
}

const activeClass = (link) => {
    const menuLinks = document.querySelectorAll('.bar-items a');
    menuLinks.forEach((menu, idx) => {
        if (menu.classList.contains('active')){
            menu.classList.remove('active');
        }
    })
    link.classList.add('active');
    const currentPosition = parseInt(link.getAttribute('data-position'));
    const barBgEl = document.querySelector('.progress-bg');
    const barBgElMobile = document.querySelector('.progress-bg-mobile');
    const color1 = barBgEl.getAttribute('data-bg1');
    const color2 = barBgEl.getAttribute('data-bg2');
    // background: linear-gradient({{section.settings.bg_color_2}} 25%, {{section.settings.bg_color_2}}00 50%);
    const qtyLinks = document.querySelectorAll('.bar-items a').length;
    let usableIndex = currentPosition;
    /*if(currentPosition > 1){
        if (currentPosition > qtyLinks) usableIndex = slides.length;
        const fadePercentage = 100 / (qtyLinks + 1);
        const currentFade = fadePercentage * (usableIndex + 0.75);
        barBgEl.style.backgroundImage = `linear-gradient(${color2} ${currentFade - 20}%, ${color2}00 ${currentFade - 10}%)`;
        barBgElMobile.style.backgroundImage = `linear-gradient(to right, ${color2} ${currentFade - 20}%, ${color2}00 ${currentFade - 10}%)`;
    }else{
        barBgEl.style.backgroundImage = `linear-gradient(${color2} 0%, ${color2}00 0%)`;
        barBgElMobile.style.backgroundImage = `linear-gradient(to right, ${color2} 0%, ${color2}00 0%)`;
    }*/
    //move scroll horizontal da barra
    const barElement = document.querySelector('.lagarh-sustainability-bar');
    const scrollWidth = barElement.scrollWidth;
    if(scrollWidth > window.innerWidth){
        const left = link.offsetLeft;
        barElement.scrollLeft = left;
    }

    //ajuste posicao desktop
    const containerHeight = barBgEl.offsetHeight;
    const positionDesktop = document.querySelector(`.progress-bg .bg-point[data-position="${currentPosition}"]`).offsetTop;
    const positionTopPercentage = (positionDesktop / containerHeight) * 100;
    barBgEl.style.backgroundImage = `linear-gradient(${color2} ${positionTopPercentage - 15}%, ${color2}00 ${positionTopPercentage}%)`;

    //posicao mobile
    const containerWidthMobile = barBgElMobile.offsetWidth;
    const positionMobile = document.querySelector(`.progress-bg-mobile .bg-point[data-position="${currentPosition}"]`).offsetLeft;
    const positionLeftPercentage = (positionMobile / containerWidthMobile) * 100;
    barBgElMobile.style.backgroundImage = `linear-gradient(to right, ${color2} ${positionLeftPercentage}%, ${color2}00 ${positionLeftPercentage + 15}%)`;
}

const checkScroll = () => {
    document.querySelectorAll('.lagarh-sustainability-content').forEach((element, idx) => {
        const {top, bottom} = element.getBoundingClientRect();
        if(top <= 0 && bottom >= 0) {
            const currendId = element.getAttribute('id');
            const currentLink = document.querySelector(`a[href="#${currendId}"]`);
            if(currentLink){
                activeClass(currentLink);
            }
        }
    });
    const elBar = document.querySelector('.lagarh-sustainability-bar');
    if(window.scrollY > 140){
        elBar.classList.add('sticky');
        if(document.querySelector('.section--site-header.sticky')){
            if(document.querySelector('.section--site-header.sticky').classList.contains('scrolled-past')){
                elBar.classList.add('sticky-past');
            }else if (elBar.classList.contains('sticky-past')){
                elBar.classList.remove('sticky-past');
            }
        }
    }else{
        if (elBar.classList.contains('sticky')){
            elBar.classList.remove('sticky');
        }
        if (elBar.classList.contains('sticky-past')){
            elBar.classList.remove('sticky-past');
        }
    }
}

window.addEventListener('scroll', checkScroll);

const barItems = document.querySelector('.bar-items');

document.addEventListener('DOMContentLoaded', function() {
    activeClass(document.querySelector('.bar-items .active'));
});

/*document.addEventListener('DOMContentLoaded', function() {
    barItems.innerHTML = '';
    document.querySelectorAll('#MainContent > section').forEach((section, idx) => {
        const sustBar = document.querySelector('.lagarh-sustainability');
        if(!section.contains(sustBar)){
            const currentId = section.getAttribute('id');
            const elTitle = section.querySelector('h2');
            if(elTitle){
                const currentTitle = elTitle.innerText;
                const link = document.createElement('a');
                link.classList.add('bar-item');
                link.href = `#${currentId}`;
                link.innerText = currentTitle;
                barItems.appendChild(link);
                link.addEventListener('click', function(e){
                    e.preventDefault();
                    moveBar(e);
                })
            }
        }
    });
})*/